import FilterOption from "../../../components/FilterOption";
import FilterText from "../../../components/FilterText";
import FilterDate from "../../../components/FilterDate";
import BaseButton from "../../../components/BaseButton";
import { formatCPF, hasInvalidDateFilter } from "../../../utils/utils";
import React from "react";
import { frontEnvelopeStatusToBack,frontRuleAnalysisStatus } from "../../../utils/utils";

export const FilterGroup = (props) => {

    const { filters, setFilters, onFilter, filterLoading } = props
    const invalidDate = hasInvalidDateFilter(filters)

    function handleKeyDown(event) {
        if (event.key === "Enter" && !invalidDate)
            onFilter()
    }

    function handleSetFilters(newFilters) {
        if (newFilters.rule_analysis_status === 'in_manual_analysis' &&
            filters.rule_analysis_status !== 'in_manual_analysis') {
            setFilters({ ...newFilters, status: 'in_manual_analysis' })
        } else {
            setFilters(newFilters)
        }
    }

    return (
        <div className="filter-container">
            <FilterText 
                id={"name"}
                labelValue={"Nome do Assinante"}
                filters={filters}
                setFilters={setFilters}
                placeholder={"Nome do Assinante"}
                handleEnter={handleKeyDown}
            />
            <FilterText
                id={"document_number"}
                labelValue={"Documento do Assinante"}
                filters={filters}
                setFilters={setFilters}
                placeholder={"000.000.000-00"}
                formatter={(value)=>formatCPF(value)}
                handleEnter={handleKeyDown}
            />
            <FilterText 
                id={"external_id"}
                labelValue={"ID do Envelope"}
                filters={filters}
                setFilters={setFilters}
                placeholder={"ID do Envelope"}
                handleEnter={handleKeyDown}
            />
            <FilterText 
                id={"subject"}
                labelValue={"Nome do Envelope"}
                filters={filters}
                setFilters={setFilters}
                placeholder={"Nome do Envelope"}
                handleEnter={handleKeyDown}
            />
            <FilterOption
                id={"status"}
                labelValue={"Status do Envelope"}
                frontEnvelopeStatus={frontEnvelopeStatusToBack}
                filters={filters}
                setFilters={handleSetFilters}
            />
            <FilterOption
                id={"rule_analysis_status"}
                labelValue={"Status de Regra"}
                frontEnvelopeStatus={frontRuleAnalysisStatus}
                filters={filters}
                setFilters={handleSetFilters}
                showAllOptions={false}
            />
            <FilterDate 
                id={"initial_date"}
                labelValue={"Data inicial"}
                filters={filters}
                setFilters={setFilters}
                handleEnter={handleKeyDown}
            />
            <FilterDate 
                id={"final_date"}
                labelValue={"Data final"}
                filters={filters}
                setFilters={setFilters}
                handleEnter={handleKeyDown}
            />
            <BaseButton
                label="Filtrar"
                onClick={() => onFilter()}
                className="filter__btn btn btn--animated btn--white"
                loading={filterLoading}
                isDisabled={invalidDate}
            />
        </div>
    );
}